<template>
  <v-row justify="center">
    <v-col md="12" cols="12">
      <h1 class="mb-5" v-html="$t('booking.booking_date2_label')" />
      <v-card class="card-date" elevation="4" :loading="loading">
        <v-card-text class="body-card-date">
          <div v-for="item in diasSemanas" :key="item.id">
            <v-btn
              text width="4px"
              :color="item.id === reservation.scheduleday_id ? 'primary' : 'black'"
              @click="chooseDay(item)"
              :disabled="loading"
              :data-testid="`DataPass-` + item.value"
            >
              <div class="button-body-card-date">
                <span v-html="item.title" />
                <span v-html="item.subtitle" />
              </div>
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions class="footer-body-card-date">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-model="date" width="60%"
                v-bind="attrs" v-on="on"
                outlined text color="black"
                data-testid="DataPass-MoreDates"
              >
                <span v-html="$t('booking.booking_date_label')" />
              </v-btn>
            </template>
            <v-date-picker
              :allowed-dates="allowedDates"
              v-model="date"
              no-title
              color="primary"
              @input="menu = false"
              @change="changeDay()"
              :locale="$i18n.locale"
            />
          </v-menu>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col md="12" cols="12">
      <h1 class="mb-5" v-html="$t('booking.booking_hour_label')" />
      <v-card class="card-hour" elevation="4" :loading="loading">
        <v-card-text class="body-card-hour">
          <p v-if="nothour === true" class="primary--text">
            {{ $t('booking.booking_no_reservation') }} {{scheduledays[indexglobal].label}}
          </p>
          <v-chip-group v-if="nothour === false" show-arrows class="chippersonas">
            <v-chip
              class="rounded-lg"
              outlined
              v-for="item in hours"
              :key="item.id"
              :color="item === hour?'primary':'black'"
              :text-color="item === hour?'primary':'black'"
              @click="chooseHour(item)"
              :disabled="loading"
              :data-testid="`DatePass-ChoosedHour-` + item.init + `/` + item.end"
            >
              <span v-if="item.label && item.label.length" v-html="item.label" />
              <span v-else v-html="item.init_label" />
            </v-chip>
          </v-chip-group>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" v-if="banners.length">
      <v-img
        width="100%"
        max-height="300px"
        :src="banner.image.w_1200"
        @click="clickBanner(banner, {content_home: banner}), SetBookBanner(true)"
        @load="loadBanner(banner)"
      />
    </v-col>
    <v-footer v-if="next && hour.reservation_modes" app class="pa-0">
      <v-card v-if="hour.reservation_modes.length && !hour.draft" class="body-button-nextpass-pay fix-next">
        <div
          v-for="(item,index) in hour.reservation_modes" :key="index"
          :class="hour.reservation_modes.length > 1 ? 'reserve-info-pay-plus' : 'reserve-info-pay'"
        >
          <p class="ma-0" v-html="labelReservationPayment[index]" />
          <span class="font-weight-black">{{ $n(item.reservation_fee, "currency", instance.locale) }}</span>
        </div>
        <div class="reserve-info-pay">
          <v-btn
            :loading="loading"
            class="button-nextpass text-capitalize" :small="hour.reservation_modes.length > 1?true:false"
            color="primary"
            @click="cambioPaso()"
          >
            <span>{{ $t('messages_error.continuar') }}</span>
        </v-btn>
        </div>
      </v-card>
      <v-card v-else  class="body-button-nextpass">
        <v-btn
          :loading="loading"
          class="button-nextpass text-capitalize"
          color="primary"
          @click="cambioPaso()"
          data-testid="DatePass-NextPass"
        >
          <span>{{ $t('messages_error.continuar') }}</span>
        </v-btn>
      </v-card>
    </v-footer>
    <v-bottom-sheet v-model="alerta">
      <v-sheet
        class="text-center"
        height="150px"
      >
        <v-btn
          text
          block
          color="error"
          @click="alerta = false, dianoencontrado = false"
          v-html="$t('messages_error.continuar')"
        />
        <span class="text-center text-h6">{{ alertaModal }}</span>
      </v-sheet>
    </v-bottom-sheet>
    <v-dialog
      v-model="draft"
      scrollable persistent :overlay="false"
      max-width="500px" transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          {{ getLabels('wait_list') }}
        </v-card-title>
        <v-card-text>
          <div class="draft-info">
            <span v-html="$t('booking.draft_label')" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="button-nextpass text-capitalize"
            color="primary" small
            v-html="$t('messages_error.continuar')"
            @click="cambioPaso()"
          />
          <v-btn
            class="button-nextpass text-capitalize"
            color="primary" small
            @click="closeModalDraft()"
            v-html="'Seleccionar otro horario'"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState,mapMutations,mapGetters } from "vuex";
import { reservas } from "@/services/reservas";
import { shoppingCart } from "@/services/shoppingCart";
import { bannerPopUps } from "@/services/domain";
import { track } from "../../services/track-custom";
import { profile } from '@/services/profile';
import { misMixins } from "@/mixins/mixins.js";

export default {
  name: 'DatePass',
  props: {
    reservation: Object,
    branch: Object,
    person: Number
  },
  mixins: [ misMixins ],
  data() {
    return {
      loading: true,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      nothour: false,
      next: false,
      dianoencontrado: false,
      scheduledays: [],
      hours: [],
      indexglobal: 0,
      hour: {},
      day: {},
      diaActual: '',
      endDate: '',
      alerta: false,
      idDeleteProduct: null,
      banners: [],
      banner: null,
      draft: false,
      getDatesTimeout: 0
    }
  },
  computed: {
    ...mapState('customer', ["supplier", "instance"]),
    ...mapState('profile', ["session","profile"]),
    ...mapState('bookings', ["bookPurchaseId"]),
    ...mapState('order', ["service"]),
    ...mapGetters('customer', ["getLabels"]),
    diasSemanas() {
      return this.scheduledays.filter((value, index) => {
        if (index >= this.indexglobal && index < this.indexglobal + 3) return value;
      });
    },
    alertaModal() {
      let mensaje = ''
      if(!(this.reservation.scheduleday_id > 0) && !(this.hour.label === '')) mensaje = this.$t('booking.booking_alert_data')
      if((this.reservation.scheduleday_id > 0) && !(this.hour.capacity > 0)) mensaje = this.$t('booking.booking_alert_hour')
      if(this.dianoencontrado === true) mensaje = this.$t('booking.booking_alert_day')
      return mensaje
    },
    labelReservationPayment() {
      let labelBook = [];
      if(this.hour.reservation_modes.length) {
        this.hour.reservation_modes.map(item => {
          if(item.code === 'cover') labelBook.push(this.$t('booking.value_cover'));
          if(item.code === 'table') labelBook.push(this.$t('booking.value_fix'));
          if(item.code === 'person') labelBook.push(this.$t('booking.value_person') + ' ' + this.reservation.cuantos + ' ' + this.$t('common.persons_label'));
        });
      };
      return labelBook;
    }
  },
  watch: {
    person(val) {
      this.reservation.cuantos = val;
      this.getDates();
    }
  },
  methods: {
    ...mapMutations('bookings', ["SetBookPurchaseId","SetBookBanner"]),
    cambioPaso() {
      if (!this.reservation.scheduleday_id && !this.hour.label && !this.hour.init_label || this.reservation.scheduleday_id > 0 && !this.hour.label && !this.hour.init_label) {
        this.alerta = true;
        this.dianoencontrado = false;
        return;
      } else {
        if (this.hour.reservation_modes.length) {
          let data_purchase = {
            customer_id: this.instance.id,
            supplier_id: this.supplier.id,
            session_id: this.session.id,
            service: this.service
          };
          shoppingCart.BookAddProductToCart(this.bookPurchaseId,data_purchase)
            .then(response => {
              if (this.bookPurchaseId === null) this.SetBookPurchaseId(response.data.id);
              this.next = false;
              this.$emit('nextPass', 'paso2');
            })
            .catch(error => {
              console.error(error);
            });
        } else {
          this.next = false;
          this.$emit('nextPass', 'paso2');
        };
      };
    },
    getDates() {
      clearTimeout(this.getDatesTimeout);
      this.getDatesTimeout = setTimeout( async () => {
        try {
          this.loading = true;
          const sheduledaysData = await reservas.getDays(this.branch.id, this.reservation.cuantos);
          if(sheduledaysData) {
            this.scheduledays = sheduledaysData.data.data.map((day) => ({ ...day.attributes, id: day.id, type: day.type }));
            if(this.scheduledays.length > 0) {
              this.diaActual = this.scheduledays[this.indexglobal].value;
              this.endDate = this.scheduledays[this.scheduledays.length - 1].value;
              await this.chooseDay(this.scheduledays[this.indexglobal]);
            }
            this.loading = false;
          };
        } catch (error) {
          console.error(error);
        }
      },1000);
    },
    allowedDates(val) {
      const result = this.scheduledays.filter(element => element.value === val);
      if(result.length > 0) return result[0].value;
    },
    async chooseDay(data) {
      this.day = data;
      this.reservation.scheduleday_id = this.day.id;
      this.hour = { label: "" };
      this.$emit('variabledia', this.day);
      
      const resHours = await reservas.getAvailableHoursZones(this.branch.id, this.day.value, this.person);
      this.hours = resHours.data.data[0].attributes.schemav2_book;

      if (this.hours && this.hours.length === 0) this.nothour = true;
      else this.nothour = false;

      var index = this.scheduledays.findIndex((index) => index.value === this.day.value);
      this.indexglobal = index;
    },
    chooseHour(data) {
      this.hour = data;
      this.$emit('variablehora', this.hour);
      if (this.hour.reservation_modes.length && !this.hour.draft) this.validateProfile();
      if (this.hour.draft) {
        this.reservation.draft = this.hour.draft;
        this.draft = true;
      } else {
        this.reservation.draft = false;
        this.draft = false;
        this.next = true;
      };
    },
    changeDay(){
      var index = this.scheduledays.findIndex((index) => index.value === this.date);
      if(index === -1) {
        this.alerta = true;
        this.dianoencontrado = true;
      } else {
        var item = this.scheduledays.find((index) => index.value === this.date);
        this.indexglobal = index;
        this.chooseDay(item);
      };
    },
    loadBanner(content_home) {
      track.trackEventCluvi({content_home: content_home}, 'open banner');
    },
    async getBanners() {
      try {
        const bannerData = await bannerPopUps.getBanners('banner-reserva');
        if(bannerData) {
          this.banners = bannerData.data;
          if(this.banners.length > 0) this.banner = this.banners[0];
        };
      } catch (error) {
        console.error(error);
      };
    },
    closeModalDraft() {
      this.hour = {};
      this.draft = false;
    },
    validateProfile () {
      if (!this.profile.id && !this.profile.token) profile.init();
    }
  },
  mounted() {
    this.getBanners();
    this.getDates();
  }
}
</script>

<style lang="scss">
  .footer-body-card-date {
    margin-top: 2rem !important;
    padding: 0rem !important;
    display: flex;
    flex-direction: column;
  }
  .body-button-nextpass-pay {
    font-family: 'Poppins', sans-serif !important;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    //height: 8rem;
    width: 100%;
    padding: 1rem;
    .reserve-info-pay {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: left;
      span {
        font-size: 1.5rem;
      }
    }
    }
    .draft-info {
      span {
        font-size: 1rem;
        line-height: 1rem;
      }
    .reserve-info-pay-plus {
      display: flex;
      flex-direction: column;
      margin: 0.5rem;
    }
    .button-nextpass {
      height: 3rem !important;
      border-radius: 10px !important;
      span {
        font-size: 1rem;
      }
    }
  }
  .body-button-nextpass {
    font-family: 'Poppins', sans-serif !important;
    display: flex;
    flex-direction: column;
    height: 6rem;
    width: 100%;
    .button-nextpass {
      margin: 2rem 3rem 3rem 3rem;
      //height: 3rem !important;
      //margin: 0  !important;
      height: auto !important;
      border-radius: 10px !important;
    }
  }
  .card-date {
    font-family: 'Poppins', sans-serif !important;
    height: 10rem;
    border-radius: 16px !important;
    text-align: center !important;

    .body-card-date {
      display: flex;
      flex-direction: row;
      padding: 1rem 0rem 1rem 0rem;
      justify-content: space-evenly;
      .button-body-card-date {
        display: flex;
        flex-direction: column;
        height: 1rem;
        span{
          &:nth-child(2){
            font-size: 11px;
          }
        }
      }
    }
  }
  .card-hour {
    font-family: 'Poppins', sans-serif !important;
    height: 6rem;
    border-radius: 16px !important;
    text-align: center !important;
    .body-card-hour {
      padding: 1.5rem 1rem 2rem 1rem;
      .chippersonas .v-slide-group__next, .chippersonas .v-slide-group__prev{
        min-width: 3rem !important;
      }
    }
  }
  .fix-next{
    flex-flow: column;
    padding: 21px;
    .reserve-info-pay-plus{
      display: flex;
      p{
        margin: 0 7px 0 0 !important;
      }
    }
  }
</style>
